import * as React from "react"

function SvgComponent(props) {
    return (
        <svg
            width={18}
            height={18}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g
                clipPath="url(#clip0_10214_1460)"
                stroke="#fff"
                strokeWidth={1.25}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M15.27 1.77l.96.96a.898.898 0 010 1.29L4.02 16.23a.898.898 0 01-1.29 0l-.96-.96a.908.908 0 010-1.29L13.98 1.77a.908.908 0 011.29 0zM10.5 5.25l2.25 2.25M3.75 4.5v3M14.25 10.5v3M7.5 1.5V3M5.25 6h-3M15.75 12h-3M8.25 2.25h-1.5" />
            </g>
            <defs>
                <clipPath id="clip0_10214_1460">
                    <path fill="#fff" d="M0 0H18V18H0z" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default SvgComponent
